<template lang="pug">
.m-card
  .m-card-header-wrapper(
    :data-bs-toggle="source.items[0].marketId != 3 ? 'collapse' : null"
    :href="source.items[0].marketId != 3 ? '#collapse-match-' + index + source.items[0].marketId : null"
    role='button'
    :aria-expanded="source.items[0].marketId == 3 ? 'true' : 'false'"
    :aria-controls="'collapse-match-' + index + source.items[0].marketId"
  )
    efTimer(:source="source.items[0]")
    .mainmarket-item-match
      .team1
        img.characters(:src="getImage(source.items[0].sportsId, source.items[0].matchBody[22])")
        span.name {{ source.items[0].homeTeam }}
      .vs
        img.img-fluid(src='images/vgame/vs.svg')
      .team2
        img.characters(:src="getImage(source.items[0].sportsId, source.items[0].matchBody[23])")
        span.name {{ source.items[0].awayTeam }}

  .m-card-body.collapse.show(
    v-if="source.items[0].marketId != 3"
    :id="'collapse-match-' + index + source.items[0].marketId"
  )
    .m-card-item
      .m-card-wrap
        .m-group
          .section.winners-market
            .odds-group
              .col
                .row
                  template(v-if="source.items[0] && source.items[0].details['ml'] && source.items[0].details['ml'][0] && source.items[0].details['ml'][0][5] != 0 && source.items[0].details['ml'][0][5] != ''")
                    OddsItem(:odds="source.items[0].details['ml'][0]" idx=5 :typ="oddsType" dataType="2" label="MLHOME")
                  template(v-else)
                    OddsDisabled
                .row
                  template(v-if="source.items[0] && source.items[0].details['cs'] && source.items[0].details['cs'][3] && source.items[0].details['cs'][3][5] != 0 && source.items[0].details['cs'][3][5] != ''")
                    OddsItem.col(:odds="source.items[0].details['cs'][3]" idx=5 :typ="oddsType" dataType="3" label="CS_2_1")
                  template(v-else)
                    OddsDisabled.col
                  template(v-if="source.items[0] && source.items[0].details['cs'] && source.items[0].details['cs'][2] && source.items[0].details['cs'][2][5] != 0 && source.items[0].details['cs'][2][5] != ''")
                    OddsItem.col(:odds="source.items[0].details['cs'][2]" idx=5 :typ="oddsType" dataType="3" label="CS_2_0")
                  template(v-else)
                    OddsDisabled.col
                .row
                  template(v-if="source.items[3] && source.items[3].details['ml'] && source.items[3].details['ml'][0] && source.items[3].details['ml'][0][5] != 0 && source.items[3].details['ml'][0][5] != ''")
                    OddsItem.col(:odds="source.items[3].details['ml'][0]" idx=5 :typ="oddsType" dataType="2" label="R_3_W")
                  template(v-else)
                    OddsDisabled.col
                  template(v-if="source.items[2] && source.items[2].details['ml'] && source.items[2].details['ml'][0] && source.items[2].details['ml'][0][5] != 0 && source.items[2].details['ml'][0][5] != ''")
                    OddsItem.col(:odds="source.items[2].details['ml'][0]" idx=5 :typ="oddsType" dataType="2" label="R_2_W")
                  template(v-else)
                    OddsDisabled.col
                  template(v-if="source.items[0] && source.items[0] && source.items[0].sportsId && racingList7.includes(source.items[0].sportsId)")
                    template(v-if="source.items[1] && source.items[1].details['ml'] && source.items[1].details['ml'][0] && source.items[1].details['ml'][0][5] != 0 && source.items[1].details['ml'][0][5] != ''")
                      OddsItem.col(:odds="source.items[1].details['ml'][0]" idx=5 :typ="oddsType" dataType="2" label="R_1_W")
                    template(v-else)
                      OddsDisabled.col
                .row(v-if="source.items[0] && source.items[0] && source.items[0].sportsId && racingList7.includes(source.items[0].sportsId)")
                  template(v-if="source.items[6] && source.items[6].details['ml'] && source.items[6].details['ml'][0] && source.items[6].details['ml'][0][5] != 0 && source.items[6].details['ml'][0][5] != ''")
                    OddsItem.col(:odds="source.items[6].details['ml'][0]" idx=5 :typ="oddsType" dataType="2" label="EF8_R3_1STBOOM")
                  template(v-else)
                    OddsDisabled.col
                  template(v-if="source.items[5] && source.items[5].details['ml'] && source.items[5].details['ml'][0] && source.items[5].details['ml'][0][5] != 0 && source.items[5].details['ml'][0][5] != ''")
                    OddsItem.col(:odds="source.items[5].details['ml'][0]" idx=5 :typ="oddsType" dataType="2" label="EF8_R2_1STBOOM")
                  template(v-else)
                    OddsDisabled.col
                .row
                  template(v-if="source.items[0] && source.items[0] && source.items[0].sportsId && !racingList7.includes(source.items[0].sportsId)")
                    template(v-if="source.items[1] && source.items[1].details['ml'] && source.items[1].details['ml'][0] && source.items[1].details['ml'][0][5] != 0 && source.items[1].details['ml'][0][5] != ''")
                      OddsItem.col(:odds="source.items[1].details['ml'][0]" idx=5 :typ="oddsType" dataType="2" label="R_1_W")
                    template(v-else)
                      OddsDisabled.col
                  template(v-if="source.items[0] && source.items[0] && source.items[0].sportsId && racingList7.includes(source.items[0].sportsId)")
                    template(v-if="source.items[4] && source.items[4].details['ml'] && source.items[4].details['ml'][0] && source.items[4].details['ml'][0][5] != 0 && source.items[4].details['ml'][0][5] != ''")
                      OddsItem.col(:odds="source.items[4].details['ml'][0]" idx=5 :typ="oddsType" dataType="2" label="EF8_R1_1STBOOM")
                    template(v-else)
                      OddsDisabled.col
                  template(v-if="source.items[0] && source.items[0].details['oe'] && source.items[0].details['oe'][0] && source.items[0].details['oe'][0][5] != 0 && source.items[0].details['oe'][0][5] != ''")
                    OddsItem.col(:odds="source.items[0].details['oe'][0]" idx=5 :typ="oddsType" dataType="2" label="ODD")
                  template(v-else)
                    OddsDisabled.col
              .col
                .row
                  template(v-if="source.items[0] && source.items[0].details['ml'] && source.items[0].details['ml'][0] && source.items[0].details['ml'][0][7] != 0 && source.items[0].details['ml'][0][7] != ''")
                    OddsItem.col(:odds="source.items[0].details['ml'][0]" idx=7 :typ="oddsType" dataType="2" label="MLAWAY")
                  template(v-else)
                    OddsDisabled.col
                .row
                  template(v-if="source.items[0] && source.items[0].details['cs'] && source.items[0].details['cs'][1] && source.items[0].details['cs'][1][5] != 0 && source.items[0].details['cs'][1][5] != ''")
                    OddsItem.col(:odds="source.items[0].details['cs'][1]" idx=5 :typ="oddsType" dataType="3" label="CS_1_2")
                  template(v-else)
                    OddsDisabled.col
                  template(v-if="source.items[0] && source.items[0].details['cs'] && source.items[0].details['cs'][0] && source.items[0].details['cs'][0][5] != 0 && source.items[0].details['cs'][0][5] != ''")
                    OddsItem.col(:odds="source.items[0].details['cs'][0]" idx=5 :typ="oddsType" dataType="3" label="CS_0_2")
                  template(v-else)
                    OddsDisabled.col
                .row(v-if="source.items[0] && source.items[0] && source.items[0].sportsId && !racingList7.includes(source.items[0].sportsId)")
                  template(v-if="source.items[3] && source.items[3].details['ml'] && source.items[3].details['ml'][0] && source.items[3].details['ml'][0][7] != 0 && source.items[3].details['ml'][0][7] != ''")
                    OddsItem.col(:odds="source.items[3].details['ml'][0]" idx=7 :typ="oddsType" dataType="2" label="R_3_W")
                  template(v-else)
                    OddsDisabled.col
                  template(v-if="source.items[2] && source.items[2].details['ml'] && source.items[2].details['ml'][0] && source.items[2].details['ml'][0][7] != 0 && source.items[2].details['ml'][0][7] != ''")
                    OddsItem.col(:odds="source.items[2].details['ml'][0]" idx=7 :typ="oddsType" dataType="2" label="R_2_W")
                  template(v-else)
                    OddsDisabled.col
                .row(v-if="source.items[0] && source.items[0] && source.items[0].sportsId && racingList7.includes(source.items[0].sportsId)")
                  template(v-if="source.items[1] && source.items[1].details['ml'] && source.items[1].details['ml'][0] && source.items[1].details['ml'][0][7] != 0 && source.items[1].details['ml'][0][7] != ''")
                    OddsItem.col(:odds="source.items[1].details['ml'][0]" idx=7 :typ="oddsType" dataType="2" label="R_1_W")
                  template(v-else)
                    OddsDisabled.col
                  template(v-if="source.items[2] && source.items[2].details['ml'] && source.items[2].details['ml'][0] && source.items[2].details['ml'][0][7] != 0 && source.items[2].details['ml'][0][7] != ''")
                    OddsItem.col(:odds="source.items[2].details['ml'][0]" idx=7 :typ="oddsType" dataType="2" label="R_2_W")
                  template(v-else)
                    OddsDisabled.col
                  template(v-if="source.items[3] && source.items[3].details['ml'] && source.items[3].details['ml'][0] && source.items[3].details['ml'][0][7] != 0 && source.items[3].details['ml'][0][7] != ''")
                    OddsItem.col(:odds="source.items[3].details['ml'][0]" idx=7 :typ="oddsType" dataType="2" label="R_3_W")
                  template(v-else)
                    OddsDisabled.col
                .row(v-if="source.items[0] && source.items[0] && source.items[0].sportsId && racingList7.includes(source.items[0].sportsId)")
                  template(v-if="source.items[5] && source.items[5].details['ml'] && source.items[5].details['ml'][0] && source.items[5].details['ml'][0][7] != 0 && source.items[5].details['ml'][0][7] != ''")
                    OddsItem.col(:odds="source.items[5].details['ml'][0]" idx=7 :typ="oddsType" dataType="2" label="EF8_R2_1STBOOM")
                  template(v-else)
                    OddsDisabled.col
                  template(v-if="source.items[6] && source.items[6].details['ml'] && source.items[6].details['ml'][0] && source.items[6].details['ml'][0][7] != 0 && source.items[6].details['ml'][0][7] != ''")
                    OddsItem.col(:odds="source.items[6].details['ml'][0]" idx=7 :typ="oddsType" dataType="2" label="EF8_R3_1STBOOM")
                  template(v-else)
                    OddsDisabled.col
                .row
                  template(v-if="source.items[0] && source.items[0] && source.items[0].sportsId && !racingList7.includes(source.items[0].sportsId)")
                    template(v-if="source.items[1] && source.items[1].details['ml'] && source.items[1].details['ml'][0] && source.items[1].details['ml'][0][7] != 0 && source.items[1].details['ml'][0][7] != ''")
                      OddsItem.col(:odds="source.items[1].details['ml'][0]" idx=7 :typ="oddsType" dataType="2" label="R_1_W")
                    template(v-else)
                      OddsDisabled.col
                  template(v-if="source.items[0] && source.items[0].details['oe'] && source.items[0].details['oe'][0] && source.items[0].details['oe'][0][7] != 0 && source.items[0].details['oe'][0][7] != ''")
                    OddsItem.col(:odds="source.items[0].details['oe'][0]" idx=7 :typ="oddsType" dataType="2" label="EVEN")
                  template(v-else)
                    OddsDisabled.col
                  template(v-if="source.items[0] && source.items[0] && source.items[0].sportsId && racingList7.includes(source.items[0].sportsId)")
                    template(v-if="source.items[4] && source.items[4].details['ml'] && source.items[4].details['ml'][0] && source.items[4].details['ml'][0][7] != 0 && source.items[4].details['ml'][0][7] != ''")
                      OddsItem.col(:odds="source.items[4].details['ml'][0]" idx=7 :typ="oddsType" dataType="2" label="EF8_R1_1STBOOM")
                    template(v-else)
                      OddsDisabled.col
</template>

<script>
import config from '@/config';
import mixinHDPOUOdds from '@/library/mixinHDPOUOdds';

export default {
  components: {
    efTimer: () => import('@/components/mobile/efight/efTimer'),
    OddsItem: () => import('@/components/mobile/main/xitem/oddsItem'),
    OddsDisabled: () => import('@/components/mobile/main/xitem/oddsDisabled')
  },
  mixins: [mixinHDPOUOdds],
  props: {
    source: {
      type: Object,
      default: null
    },
    index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    oddsType() {
      return this.$store.getters.pageDisplay.oddsType;
    },
    racingList() {
      return config.racingList;
    },
    racingList7() {
      return config.racingList7;
    },
    newFeatures() {
      return config.newFeatures;
    }
  },
  methods: {
    team(player, pos, isTeam) {
      if (isTeam) {
        return player.homeTeam;
      }

      return player.homeTeam.split(' - ')[pos];
    },
    getImage(s, img) {
      return config.resourceImgUrl + "/ef/" + (this.newFeatures ? 'uat/' : 'prod/') + s + "/" + img + ".png";
    }
  }
};
</script>